import { createFileRoute, Outlet } from '@tanstack/react-router';
import { requireRole } from '../lib/auth-guard.js';

// Layout-Route für /admin/workers. Rendert NUR die Kind-Routen via <Outlet/>:
// die Liste liegt in admin.workers.index.tsx, das Detail in admin.workers.$id.tsx.
export const Route = createFileRoute('/admin/workers')({
  component: AdminWorkersLayout,
  beforeLoad: async ({ context }) => {
    await requireRole(context.queryClient, ['ceo', 'internal_staff']);
  },
});

function AdminWorkersLayout() {
  return <Outlet />;
}
